import { useSeo } from "@/lib/seo";
import { IMAGES } from "@/data/site";
import PageHero from "@/components/PageHero";
import { Reveal, Overline } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";
import { Check } from "lucide-react";

const FOCUS = [
  "Entitled lots", "Workforce housing", "Build-to-rent (BTR)", "Single-family development",
  "Utility-integrated neighborhoods", "Energy efficiency", "Heat reuse",
];

export default function Residential() {
  useSeo("Residential & Workforce Housing Development | 12 Stone",
    "12 Stone develops entitled lots, workforce housing, build-to-rent and utility-integrated neighborhoods with energy efficiency and heat reuse across Georgia and the Southeast.");
  return (
    <div>
      <PageHero overline="Residential Development" title="Housing That Supports Real Growth"
        subtitle="Entitled residential projects designed to support growing communities and the employment centers that new infrastructure creates."
        image={IMAGES.residential} />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <Overline>What We Develop</Overline>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl font-bold text-foreground text-balance">Utility-integrated, energy-efficient communities</h2>
          <p className="mt-5 text-muted-foreground leading-relaxed">
            As power-intensive and industrial development creates new jobs, communities need housing to match.
            12 Stone develops entitled residential projects with modern utility integration and efficiency in mind.
          </p>
          <ul className="mt-7 space-y-3">
            {FOCUS.map((f) => (
              <li key={f} className="flex items-center gap-3 text-foreground/90"><Check className="h-5 w-5 text-primary shrink-0" /> {f}</li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="rounded-xl overflow-hidden border border-border"><img src={IMAGES.aerialLand} alt="Aerial development site" className="w-full h-full object-cover" /></div>
        </Reveal>
      </section>

      <section className="border-t border-border bg-secondary">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {[
            { title: "Available Residential Opportunities", type: "contact", cat: "Available Residential Opportunities", label: "Ask about availability" },
            { title: "Builder Inquiry", type: "partner", cat: "Builder Inquiry", label: "Builder inquiry" },
            { title: "BTR Investor Inquiry", type: "partner", cat: "BTR Investor Inquiry", label: "BTR investor inquiry" },
          ].map((c, i) => (
            <Reveal key={c.title} delay={i * 0.06}>
              <div className="rounded-xl border border-border bg-card p-6 h-full">
                <h3 className="font-display text-lg font-semibold text-foreground mb-4">{c.title}</h3>
                <LeadForm leadType={c.type} defaultCategory={c.cat} submitLabel="SUBMIT" testId={`residential-${i}`} compact showCompany={i > 0} />
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
